// Mutations
import addPreOrderUnit from "./AddPreOrderUnitMutation.gql";

export const Mutation = {
    addPreOrderUnit,
};
